var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Click "),_c('a',{attrs:{"href":"https://stats.uptimerobot.com/ZrV89sM1jA"}},[_vm._v("here")]),_vm._v("!")])])}]

export { render, staticRenderFns }